import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	remixTooltip: {
		id: 'highlight-actions.remix.inline-toolbar-tooltip',
		defaultMessage: 'Remix',
		description: 'Tooltip for the Remix button in the editor inline toolbar',
	},
	remixLabel: {
		id: 'highlight-actions.remix.inline-toolbar-label',
		defaultMessage: 'Remix',
		description: 'Label for the Remix button in the editor inline toolbar',
	},
});
